import { Component, Injectable, OnInit, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { QueueAgentComponent } from './queue_agent.component';
import { QueueService } from '../../../../../common/services/Queue.service';
import { ServiceService } from '../../../../../common/services/Service.service';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.css'],
  providers: [QueueService, BsModalService, ServiceService],
})
@Injectable()
export class QueueComponent implements OnInit {
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();

  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public message: { class: string; content: string } = null;
  public list: any = [];
  public model: any = {};
  public modelFilter: any = {};
  public typeModal: string;
  public modalRef: any = {};
  public modalRef2: any = {};
  public types: any = [];
  totalItem: any = 0;
  totalPage: any = 0;

  public id_delete: number;
  public allQueueManager: any = [{ id: '', text: 'Chọn queue' }];
  public allService: any = [];
  public allParam: any = [];
  public current_queue_id: any = null;
  public actionParam: any = 'add';
  public modelAddParam: any = {};
  public is_load_data = false;
  bsModalRef: BsModalRef;

  public user: any = {};

  constructor(
    private queueService: QueueService,
    private modalService: BsModalService,
    private serviceService: ServiceService,
    private toastr: ToastrService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnInit() {
    this.is_load_data = true;
    this.current_queue_id = null;
    this.modelAddParam = {};
    this.model = {};
    this.loadData();
    this.getService();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.is_load_data = false;
    }, 1000);
  }

  loadData(request: any = {}, sort: any = {}) {
    this.list = [];
    this.model = {};
    request.offset = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }

    this.queueService
      .list(request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.list = res.data.queues;
            this.totalItem = res.data.total;
            const pageString = (this.totalItem / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.list = [];
            // this.genDataTable();
            this.scrollToTop();
          }
        },
        err => {
          this.message = {
            class: 'alert dark alert-danger',
            content: err.message,
          };
          this.list = [];
          // this.genDataTable();
          this.scrollToTop();
        }
      );
  }

  scrollToTop() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  search() {
    this.currentPage = 1;
    let objFind = {};
    let check = false;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      objFind = { description: this.modelFilter.keyword.trim() };
      check = true;
    }
    if (this.modelFilter.service_id) {
      objFind['service_id'] = this.modelFilter.service_id;
      check = true;
    }

    if (check) {
      this.loadData(objFind);
    } else {
      this.loadData();
    }
  }

  openModalParam(template: TemplateRef<any>, id?: any) {
    this.current_queue_id = id;
    this.loadParam(this.current_queue_id);
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-lg',
    };
    this.modalRef = this.modalService.show(template, config);
  }

  loadParam(queue_id) {
    this.queueService.allParam({ queue_id: queue_id }).subscribe(rs => {
      this.allParam = rs.data;
    });
  }

  showAgent(queue_id) {
    this.current_queue_id = queue_id;
    const initialState = {
      queue_id: this.current_queue_id,
    };
    // let config = {
    //     backdrop: true,
    //     ignoreBackdropClick: true,
    //     keyboard: false,
    //     initialState: {
    //         queue_id: this.current_queue_id,
    //     }
    // }
    this.bsModalRef = this.modalService.show(QueueAgentComponent, {
      initialState,
    });
  }

  openModalAddParam(template: TemplateRef<any>, param?: any, type?: any) {
    this.message = null;
    this.actionParam = type;
    this.modelAddParam = {
      PARAM_ID: param.PARAM_ID,
      VALUE: param.VALUE,
      DESCRIPTION: param.PARAM_DESC,
    };
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef2 = this.modalService.show(template, config);
  }

  addParam() {
    // if(!this.modelAddParam.VALUE)
    //     this.message = { class: "alert dark alert-danger", content: "Giá trị không được bỏ trống !" };
    // else{
    this.queueService.addParam(this.current_queue_id, this.modelAddParam).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Lưu không thành công',
            };
            this.toastr.error('Lưu thất bại', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Thêm mới thành công',
            };
            this.toastr.success('Cập nhật thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });

            this.loadParam(this.current_queue_id);
            this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
    // }
  }

  getService() {
    this.serviceService.allService().subscribe(rs => {
      const serviceList = [{ id: '-1', text: 'Chọn' }];
      rs.data.forEach((c: any) => {
        serviceList.push({
          text: c.name,
          id: c.id.toString(),
        });
      });
      this.allService = serviceList;
    });
  }

  openModal(template: TemplateRef<any>, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.is_load_data = true;
    this.modalRef = this.modalService.show(template, config);

    this.typeModal = id ? 'edit' : 'add';
    this.model = {};

    this.queueService.allQueueManager().subscribe(rs => {
      const managerList = [{ id: '', text: 'Chọn' }];
      rs.data.forEach((c: any) => {
        managerList.push({
          text: c.DESCRIPTION,
          id: c.QUEUE_MANAGER_ID.toString(),
        });
      });
      this.allQueueManager = managerList;
      setTimeout(() => {
        this.is_load_data = false;
      }, 1000);
    });

    if (id) {
      this.is_load_data = true;
      this.queueService
        .find(id)
        .toPromise()
        .then(rs => {
          this.model = rs.data;
          this.is_load_data = false;
        });
    }
  }

  add() {
    if (!this.model.DESCRIPTION || (this.model.DESCRIPTION && this.model.DESCRIPTION.trim() == '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên Queue không được bỏ trống !',
      };
    } else {
      this.queueService.create(this.model).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Thêm mới không thành công',
              };
              this.toastr.error('Thêm mới thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Thêm mới thành công',
              };
              this.toastr.success('Thêm mới thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });

              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  edit(data) {
    this.message = null;

    if (!this.model.DESCRIPTION) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Url không được bỏ trống !',
      };
    } else {
      const payload = {};
      if (this.model.DESCRIPTION) {
        payload['DESCRIPTION'] = this.model.DESCRIPTION;
      }
      if (this.model.SERVICE_ID) {
        payload['SERVICE_ID'] = this.model.SERVICE_ID;
      }
      if (this.model.QUEUE_MANAGER_ID) {
        payload['QUEUE_MANAGER_ID'] = this.model.QUEUE_MANAGER_ID;
      }
      this.queueService.update(this.model.QUEUE_ID, payload).subscribe(
        res => {
          if (res) {
            const error = res.error;
            if (error) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Cập nhật không thành công',
              };
              this.toastr.error('Cập nhật thất bại', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.message = {
                class: 'alert dark alert-success',
                content: 'Cập nhật thành công',
              };
              this.toastr.success('Cập nhật thành công', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
              this.loadData();
              this.modalRef.hide();
            }
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
    this.scrollToTop();
  }

  public changeQueueManager(e: any): void {
    if (!this.is_load_data) {
      this.model.QUEUE_MANAGER_ID = e.value;
    }
  }

  public changeService(e: any): void {
    if (!this.is_load_data) {
      this.model.SERVICE_ID = e.value;
    }
  }

  public changeServiceFilter(e: any): void {
    if (!this.is_load_data) {
      this.modelFilter.service_id = e.value;
    }
  }

  openConfirmDelete(template: TemplateRef<any>, id) {
    this.id_delete = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.submitDelete();
    }
  }

  submitDelete() {
    this.queueService._delete(this.id_delete).subscribe(
      res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.message = {
              class: 'alert dark alert-danger',
              content: 'Xóa không thành công',
            };
            this.toastr.error('Xóa không thành công', error.message, {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.message = {
              class: 'alert dark alert-success',
              content: 'Xóa thành công',
            };
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            this.loadData();
            // this.modalRef2.hide();
          }
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
        this.toastr.error('Xóa không thành công', error.message, {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    );
  }

  setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData();
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData();
        }
      }
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/queue/queue.component.ts